// extracted by mini-css-extract-plugin
export default {"container":"S04_container__DaUgH","section":"S04_section__GpJAM","limiter":"S04_limiter__F-BxM"};